import { fetchWorkdays, filterAction, resetFilterAction } from '../actions/index';
import ClaimsEmployeesWorkday from './claims-employees-workday';
import AdminCommonSection from '../components/adminLayout';
import {React, Component, bindActionCreators, connect, Filters, Pagination, 
    constants, KeolisSpinner, moment} from './common/commonExport';
import PDFPrinting from './PDFPrinting';
import AuditTrailComp from '../components/AuditTrail';

class AuditTrail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            totalRecords: '',
            numberOfPages: '',
            pageNum: 1, 
            filterState:{}
        }
    }

    // get data for component
    getData(pageNum, filterObj){
        if(filterObj){
            filterObj = filterObj;
        } else {
            filterObj = this.state.filterState;
        }
        let self = this,
            authDetails = this.props.authDetails,
            role = authDetails.role;
            pageNum = filterObj.byPagination ? (pageNum) : (filterObj.byFilter ? 1 : pageNum);
        if(role == constants.roles.ADMIN_ROLE){
            let fetchObj = {
                url:constants.actionUrls.ADMIN_URL,
                role: role,
                route: constants.AUDIT_TRAIL,
                pageNum:pageNum,
                filterObj:filterObj
            }
            this.props.fetchWorkdays(fetchObj, function(response){
                self.setState({
                    numberOfPages: response.totalPages,
                    pageNum: pageNum
                })
            });
            localStorage.setItem('route', constants.AUDIT_TRAIL);
        }
    };

    // reset the filter
    resetFilter(filterObj){
        let self = this;   
        filterObj["outlaw"] = false;
        this.props.resetFilter(filterObj, function(response){
            self.setState({
                filterState:response
            });
        });
    }
    // called before the component render
    componentWillMount() {
        let filterObj = this.props.filterState && this.props.filterState.defaultState ? this.props.filterState.defaultState:
                        this.props.filterState;
        this.resetFilter(filterObj);
    }
    
    // called after the component render
    componentDidMount(){
        let pageNum = this.state.pageNum;
        this.getData(pageNum);
    }

    // rendering pagination component
    renderPagination() {
        let { pageNum, numberOfPages} = this.state,
            audits = this.props.auditData, showPagination=false;
        if(audits && audits.length > 0 && numberOfPages > 1){
            showPagination = true;
        }
        return (<Pagination ShowPagination={showPagination} currentPage={pageNum}
            pageSize={numberOfPages} GetData={(pageNum, filterObj) => this.getData(pageNum, filterObj)} />)
    }

    // rendering audit component
    renderAudits() {
        let wdy_date, then, role = this.props.authDetails.role,
            audits = this.props.auditData;
        if (this.props.isLoading) {
            return(
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        } else if (audits && audits.length > 0) {
            return ( audits.map(function (audit, index) {
                    return (
                        <AuditTrailComp audit={audit} key={index} role={role} />
                    );
                })
            )
        } else {
            return (
                <tr>
                    <td colSpan="100%">
                        No records available...
                    </td>
                </tr>
            )
        }
    }

    // filter in Action
    getFilteredData(e, data){
        let pageNum = this.state.pageNum,filterObj = data;
        if(e){
            e.preventDefault();
        } 
        this.props.submitFilter(data);
        this.getData(pageNum, filterObj);
    }

    render() {
        var route = localStorage.getItem('route') ? localStorage.getItem('route') : '',
            compTitle = constants.getComponentTitle(route);
        return (
            <AdminCommonSection compTitle={compTitle} admin={true}
                tblBody={
                    <div>
                        <Filters getData = {(e, data) => this.getFilteredData(e, data)}/>
                        <PDFPrinting Page="Projects" compTitle = {compTitle} pageNo = {this.state.pageNum}/>
                        <div id="tblMainActivities">
                            <table className="table table-striped table-bordered_header table-condensed">
                                <thead className="thead-default">
                                    <tr className="text-center">
                                        <th>Type</th>
                                        <th>Table</th>
                                        <th>Field</th> 
                                        <th>Old Value</th> 
                                        <th>New Value</th> 
                                        <th>Updated Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {        
                                    this.renderAudits()
                                }
                                </tbody>
                            </table>
                        </div>
                        { 
                            this.renderPagination()
                        }
                        </div>
                }
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        auditData: state.workdays.auditData,
        hasErrored: state.workdays.itemsHasErrored,
        isLoading: state.workdays.isLoading,
        authDetails:state.authState,
        filterState:state.filter
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            fetchWorkdays: fetchWorkdays,
            resetFilter:resetFilterAction,
            submitFilter: filterAction
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(AuditTrail);
